export const INITIAL_STATE = {
    appName: 'Conduit',
    token: null,
    viewChangeCounter: 0,
    redirectTo: null,
    currentUser: {},
    appLoaded: false,
    skipTracking: false
}